require('./RALastMovementFilter.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');

// @utilities
const { formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
const { recordLink, PROC_START } = require('utilities/tagging');

// @constants
const {
    DISTRIBUTION,
    DEPOSIT,
    FEE,
    RA_MOVEMENTS_FILTER_ALL,
    SECURITY_BUY,
    SECURITY_SELL,
    TAX,
    WITHDRAWAL,
} = require('../../../raConstants/index');

class RALastMovementFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immLastMovement } = props;

        this.state = {
            dateSelected: immLastMovement.getIn([
                'lastMovementsRow',
                'filter',
                'date',
                'selected',
            ]),
            dateFrom: immLastMovement.getIn([
                'lastMovementsRow',
                'filter',
                'date',
                'from',
            ]),
            dateTo: immLastMovement.getIn([
                'lastMovementsRow',
                'filter',
                'date',
                'to',
            ]),
            typeOfDocument: '',
            contract: '',
            contractNumber: '',
        };

        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(
            this,
        );
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        recordLink('robo-filtro-ordenes', PROC_START);
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo,
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom,
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected,
        });
    }

    getPortfolioOptions() {
        const { portfolioModalOptions } = this.props;
        let optionsArray = portfolioModalOptions.map(option => ({
            label: option.name,
            value: option.index,
        }));
        optionsArray.unshift({
            value: RA_MOVEMENTS_FILTER_ALL,
            label: toFirstUppercase(formatText('filters-all')),
        });
        return optionsArray;
    }

    handleSubmit() {
        const {
            immLastMovement,
            setFilter,
            onToggleModal,
            typeModalValue,
            requestLastMovement,
        } = this.props;
        const { dateFrom, dateTo, dateSelected } = this.state;
        const profileId = immLastMovement.getIn([
            'lastMovementsRow',
            'filter',
            'profileId',
        ]);
        const newFilter = {
            typeModalValue: typeModalValue,
            isTypeModalValueFilterActive: !(
                typeModalValue != RA_MOVEMENTS_FILTER_ALL
            ),
            profileId: profileId,
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo,
                isActive: true,
            },
        };
        setFilter(newFilter);
        requestLastMovement(profileId, true);
        onToggleModal();
    }

    render() {
        const {
            filterIsOpen,
            onTypeModalChange,
            typeModalValue,
            immLastMovement,
            onToggleModal,
        } = this.props;

        const typeModalOptions = [
            {
                value: RA_MOVEMENTS_FILTER_ALL,
                label: toFirstUppercase(formatText('filters-all')),
            },
            {
                value: SECURITY_BUY,
                label: formatText('raLastMovement-raLastMovement_SECURITY_BUY'),
            },
            {
                value: SECURITY_SELL,
                label: formatText(
                    'raLastMovement-raLastMovement_SECURITY_SELL',
                ),
            },
            {
                value: DEPOSIT,
                label: formatText('raLastMovement-raLastMovement_DEPOSIT'),
            },
            {
                value: FEE,
                label: formatText('raLastMovement-raLastMovement_FEE'),
            },
            {
                value: WITHDRAWAL,
                label: formatText('raLastMovement-raLastMovement_WITHDRAWAL'),
            },
            {
                value: DISTRIBUTION,
                label: formatText('raLastMovement-raLastMovement_DISTRIBUTION'),
            },
            {
                value: TAX,
                label: formatText('raLastMovement-raLastMovement_TAX'),
            },
        ];

        const modalContent = (
            <div className="ra-last-movement-filter">
                <DateFilter
                    immFilter={immLastMovement.getIn([
                        'lastMovementsRow',
                        'filter',
                        'date',
                    ])}
                    onChangeMin={this.handleChangeDateMin}
                    onChangeMax={this.handleChangeDateMax}
                    onChangeSelected={this.handleChangeDateSelected}
                    last={true}
                />
                <div className="row ra-last-movement__modal-select">
                    <div className="col-xs-12 col-md-6">
                        <OKSelect
                            clearable={false}
                            label={formatText(
                                'raLastMovement-raLastMovement_typeSelectLabel',
                            )}
                            onChange={onTypeModalChange}
                            options={typeModalOptions}
                            value={typeModalValue}
                            openUp={true}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={filterIsOpen}
                onCloseCallback={onToggleModal}
                onPrimaryButtonClick={this.handleSubmit}
                onSecondaryButtonClick={onToggleModal}
                primaryButtonText="raLastMovement-apply"
                secondaryButtonText="raLastMovement-cancel"
                shouldCloseOnOverlayClick={false}
                title="raLastMovement-modalTitle"
                type="filter"
            />
        );
    }
}

RALastMovementFilter.propTypes = {
    changeLastMovementFilter: PropTypes.func.isRequired,
    onTypeModalChange: PropTypes.func.isRequired,
    portfolioModalOptions: PropTypes.array,
    typeModalValue: PropTypes.string.isRequired,
    immLastMovement: PropTypes.func.isRequired,
    filterIsOpen: PropTypes.bool.isRequired,
    setFilter: PropTypes.func.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    requestLastMovement: PropTypes.func.isRequired,
};

RALastMovementFilter.defaultProps = {
    portfolioModalOptions: [],
};

module.exports = RALastMovementFilter;
